import { FieldTypes, WellEndPointFields } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import LocationFieldEdit from '../../wells/location-field-edit'
import { preventChangeOnScroll } from '../../../services/form-utils'
import { FormField, InputWidth, TextInput } from '@msaf/core-react'

interface WellEndPointEditInterface {
  fields: Partial<WellEndPointFields>
  index: number
  isLoading: boolean
  setValue: SetValue<WellEndPointFields>
  validationErrors: ValidationErrors<WellEndPointFields>
}

export default function WellEndPointEdit({
  fields,
  index,
  isLoading,
  validationErrors,
  setValue,
}: WellEndPointEditInterface) {
  return (
    <>
      <LocationFieldEdit
        isMapHidden
        isLoading={isLoading}
        labelledBy='wellEndPointCoordinates'
        easting={{
          fieldId: 'easting',
          value: `${fields.easting ?? ''}`,
          setValue: (value: FieldTypes) => setValue('easting', value),
        }}
        northing={{
          fieldId: 'northing',
          value: `${fields.northing ?? ''}`,
          setValue: (value: FieldTypes) => setValue('northing', value),
        }}
        latitude={{
          fieldId: 'latitude',
          value: `${fields.latitude ?? ''}`,
          setValue: (value: FieldTypes) => setValue('latitude', value),
        }}
        longitude={{
          fieldId: 'longitude',
          value: `${fields.longitude ?? ''}`,
          setValue: (value: FieldTypes) => setValue('longitude', value),
        }}
        index={index}
        validationFieldErrors={validationErrors}
      />
      <FormField
        isSkeleton={isLoading}
        label='Elevation'
        htmlFor='elevation'
        validationMessages={validationErrors?.elevation}
      >
        <TextInput
          isSkeleton={isLoading}
          fieldSize={InputWidth.large}
          type='number'
          onWheel={preventChangeOnScroll}
          id='elevation'
          value={`${fields.elevation ?? ''}`}
          setValue={(value) => setValue('elevation', value)}
          isInvalid={!!validationErrors?.elevation}
        />
      </FormField>
    </>
  )
}
